'use client';

import { NumberInput  } from '@chakra-ui/react';
import type { NumberInputRootProps } from '@chakra-ui/react';
import { useFormContext, Controller } from 'react-hook-form';

import type { FormBaseInputProps, FormValues } from '../../../types';
import { FormFloatingField } from '../../wrapper';

export type NumericInputProps<T> = FormBaseInputProps<T> & Omit<NumberInputRootProps, 'name'>;

export const NumericInput = <T extends FormValues>({
	helperText,
	label,
	name,
	optionalText,
	required,
	...numberInputRootProps
}: NumericInputProps<T>) => {
	const { control } = useFormContext();

	return (
		<FormFloatingField
			helperText={helperText}
			label={label}
			name={name}
			optionalText={optionalText}
			required={required}
		>
			<Controller
				control={control}
				name={name}
				render={({ field }) => (
					<NumberInput.Root
						name={field.name}
						onValueChange={({ valueAsNumber }) => field.onChange(valueAsNumber)}
						value={field.value}
						{...numberInputRootProps}
					>

						<NumberInput.Input onBlur={field.onBlur} />
					</NumberInput.Root>
				)}
			/>
		</FormFloatingField>
	);
};
